import { Company } from "./Company";

export interface NewProvider {
  name: string;
  paymentMode: number;
}

export interface Provider extends NewProvider {
  id: number;
  apiKey?: string;
  allowedIps?: string[];
  company?: Company;
}

export enum PaymentMode {
  CUSTOMER_PAYMENT = 0,
  WALLET_PAYMENT = 1,
  INVOICE_PAYMENT = 2,
  ALWAYS_OK = 3
}
